export class TrackingService {
  view(data?: unknown): void {
    console.log('View tracking called', data);
  }

  link(data?: unknown): void {
    console.log('Link tracking called', data);
  }
}
